// import { ApolloClient, createNetworkInterface } from 'react-apollo'
// import { SubscriptionClient, addGraphQLSubscriptions } from 'subscriptions-transport-ws'
// import { IntrospectionFragmentMatcher } from 'react-apollo'

import ApolloClient from 'apollo-client'
import { HttpLink, InMemoryCache } from 'apollo-client-preset'



// const SERVER = 'localhost'
const SERVER = 'registro.af7.es'
// const SERVER = '10.10.10.61'
const PORT = '5000'

// const myFragmentMatcher = new IntrospectionFragmentMatcher({
//   introspectionQueryResultData: {
//     __schema: {
//       types: [
//         {
//           kind: 'INTERFACE',
//           name: 'type',
//           possibleTypes: [
//             {name: 'TEXTFIELD'},
//             {name: 'SELECT'},
//           ],
//         },
//       ],
//     },
//   }
// })

// const networkInterface = createNetworkInterface({uri: `http://${SERVER}:${PORT}/graphql`});
// networkInterface.use([{
//     applyMiddleware: (req, next) => {
//         setTimeout(next, 500)
//     }
// }])

// const wsClient = new SubscriptionClient(`ws://${SERVER}:${PORT}/subscriptions`, {reconnect: true});
// const networkInterfaceWithSubscriptions = addGraphQLSubscriptions(networkInterface, wsClient);


// Apollo client
const client = new ApolloClient({
    link: new HttpLink({ uri:  `https://${SERVER}:${PORT}/graphql` }),
    // link: new HttpLink({ uri:  `http://${SERVER}:${PORT}/graphql` }),
    cache: new InMemoryCache().restore({})
  })
  
export default client;
  
// export const apolloClient = new ApolloClient({
//   networkInterface: networkInterfaceWithSubscriptions,
//   reduxRootSelector: state => state.get('apollo'), //This is needed to work with immutable.js
//   fragmentMatcher: myFragmentMatcher,
//   // dataIdFromObject: o => {
//   //   if (o.__typename === 'Field') return `${o.__typename}-${o.name}`
//   //   if (o.__typename === 'TextField') return `${o.__typename}-${o.name}`
//   //   if (o.__typename === 'SelectField') return `${o.__typename}-${o.name}`
//   //   return `${o.__typename}-${o.id}`
//   // }
// })


// WEBPACK FOOTER //
// ./src/apolloClient.js